<template>
	<section class="location-map-section" @click="enableScroll">
		<div class="location-map-section__content-wrapper">
			<div class="location-map-section__content">
				<h2 class="location-map-section__title">
					{{
						$t('modules.location_module.location.map_section.car_rental', {
							city: locale === 'pl' ? cmsLocation?.namePL : cmsLocation?.nameEN,
						})
					}}
					| CarFree:
				</h2>
				<div class="location-map-section__addresses">
					<template v-if="assignedLocations && assignedLocations?.length > 0">
						<div v-for="location in assignedLocations" :key="location.id" class="location-map-section__address">
							<GlobalIcon name="location" color="var(--primary-color)" :height="18" />
							<p class="location-map-section__address-text">
								{{ locationAddressLoop(location) }}
							</p>
						</div>
					</template>
					<div v-else class="location-map-section__address">
						<GlobalIcon name="location" color="var(--primary-color)" :height="18" />
						<p class="location-map-section__address-text">
							{{ locationAddress }}
						</p>
					</div>
				</div>
				<div class="location-map-section__phone-and-mail">
					<div class="location-map-section__phone">
						<div class="location-map-section__phone-icon-box">
							<GlobalIcon name="call" color="white" :height="18" />
						</div>
						<div class="location-map-section__phone-content">
							<div class="location-map-section__phone-label">
								{{ $t('modules.location_module.location.map_section.hotline') }}
							</div>
							<a :href="`tel:${phoneNumber ? phoneNumber : '+48 794 500 550'}`" class="location-map-section__phone-value">
								{{ phoneNumber ? phoneNumber : '+48 794 500 550' }}</a
							>
						</div>
					</div>
					<div class="location-map-section__mail">
						<div class="location-map-section__mail-icon-box">
							<GlobalIcon name="sms" color="white" :height="18" />
						</div>
						<div class="location-map-section__mail-content">
							<div class="location-map-section__mail-label">
								{{ $t('modules.location_module.location.map_section.reservation_handling') }}
							</div>
							<a :href="`mailto:${mailAddress}`" class="location-map-section__mail-value">{{ mailAddress }}</a>
						</div>
					</div>
				</div>
				<!-- <template v-if="sectionContent?.description && sectionContent?.description !== ''"> -->
				<v-divider class="location-map-section__divider"></v-divider>
				<div class="location-map-section__availability">
					<div class="location-map-section__availability-title">
						{{ $t('modules.location_module.location.map_section.working_hours') }}:
					</div>
					<!-- <div class="location-map-section__availability-values" v-html="sectionContent?.description"></div> -->
					<div class="location-map-section__availability-values">
						<p>
							{{ $t('modules.location_module.location.map_section.in_location') }}
							<span>
								{{ locale === 'pl' ? cmsLocation?.namePL : cmsLocation?.nameEN }}
							</span>
							{{ $t('modules.location_module.location.map_section.we_are_open') }}
							<span> 24h / 7 {{ $t('modules.location_module.location.map_section.days') }}</span>
							{{ $t('modules.location_module.location.map_section.in_a_weak') }}.
						</p>
					</div>
				</div>
				<!-- </template> -->
			</div>
			<div class="location-map-section__map">
				<LocationMap :scroll="scroll" />
			</div>
		</div>
	</section>
</template>

<script setup lang="ts">
const { locale } = useI18n()
const cmsLocation = inject<Ref<ICMSLocationModel>>('cmsLocation')!
// const pageMapSection = inject<Ref<ICMSLocationContent>>('pageMapSection')!
const assignedLocations = inject<Ref<ILocationModel[]>>('assignedLocations')!
// const sectionContent = ref<ICMSLocationContentTranslations>(
// 	pageMapSection.value?.translations.find((translation) => translation.language === locale.value)?.content[0],
// )

const scroll = ref(false)

function enableScroll() {
	scroll.value = true
}

onMounted(() => {
	console.log('cmsLocation', cmsLocation.value)
})

const locationAddress = computed(() => {
	if (assignedLocations.value && assignedLocations.value?.length > 0) {
		return `${assignedLocations.value[0].address_street} ${assignedLocations.value[0].address_house_number}, ${locale.value === 'pl' ? assignedLocations.value[0].name : assignedLocations.value[0].nameEn}`
	} else {
		return cmsLocation.value?.[`subtitle${locale.value?.toUpperCase()}`] !== '' &&
			cmsLocation.value?.[`subtitle${locale.value?.toUpperCase()}`] !== null
			? cmsLocation.value?.[`subtitle${locale.value?.toUpperCase()}`]
			: cmsLocation.value?.[`name${locale.value?.toUpperCase()}`]
	}
})

const locationAddressLoop = (location: ILocationModel) => {
	return location.address_street && location.address_house_number
		? `${location.address_street} ${location.address_house_number}, ${location.city}`
		: locale.value === 'pl'
			? location.name
			: location.nameEn
}

const phoneNumber = computed(() => {
	if (cmsLocation.value?.phoneNumber && cmsLocation.value?.phoneNumber !== '') {
		return cmsLocation.value?.phoneNumber
	} else if (assignedLocations.value && assignedLocations.value?.length > 0) {
		return assignedLocations.value[0].phone_number
	}
	return null
})

const mailAddress = computed(() => {
	if (assignedLocations.value && assignedLocations.value?.length > 0) {
		return assignedLocations.value[0].email
	} else if (cmsLocation.value?.email && cmsLocation.value?.email !== '') {
		return cmsLocation.value?.email
	}
	return 'rezerwacje@carfree.pl'
})
</script>

<style lang="scss">
@import './MapSection.scss';
</style>
